/**
 * Created by daniel on 23/04/17.
 */


import * as actions from "./actions";
import * as shortid from "shortid";
import * as _ from "lodash";


function modifyItem(contentItem, action) {
  switch (action.type) {
    case actions.ORPHAN_CONTENT_ITEM:
      // Just null the contentItem's parentId, recording the old one
      contentItem.contentOldParentId = contentItem.contentParentId;
      contentItem.contentParentId = null;
      return contentItem;
    
    case actions.RESTORE_ORPHANED_CONTENT_ITEM:
      contentItem.contentParentId = contentItem.contentOldParentId;
      contentItem.contentOldParentId = null;
      return contentItem;
    
    case actions.UPDATE_CONTENT_ITEM:
      return ((contentItem, { newProps, oldProps, defaultProps}) => {
        // Easy bit - check if any change at all.
        if (JSON.stringify(oldProps) === JSON.stringify(newProps)) return contentItem;
        
        // Construct a new item by comparing new state to defaults
        let newState = {...oldProps, ...newProps};
        let newItem = {};
        _.forOwn(defaultProps, (val, key) => {
          if (!_.has(newState, key)) return;
          let equal = _.isEqual(newState[key], val);
          if (equal && key !== "contentId" && key !== "contentIsRoot" && key !== "contentParentId" && key !== "configId") return;
          newItem[key] = newState[key];
        });
        // Add back in bare minimum props and return
        return newItem;
      })(contentItem, action);
      
    case actions.HIDE_CONTENT_ITEM:
      return ((contentItem, {contentHidden}) => {
        return {
          ...contentItem,
          contentHidden,
        }
      })(contentItem, action);
    default:
      return contentItem;
  }
}

export function content(state = [], action) {
  // State is the content array
  let contentArr = JSON.parse(JSON.stringify(state)); // Make sure we don't mutate anything.
  
  switch(action.type) {
    case actions.CREATE_CONTENT_ITEM:
      function makeItem(content, config, contentParentId, relativeToContentId, moveBelow) {
        let template = _.head(_.filter(action.contentDefs, {configId: config.configId}));
        // merge with passed def so we retain children (if any). Passed def overrides template.
        //let mergedTemplate = {...template, ...config};
        let mergedTemplate = _.defaultsDeep(JSON.parse(JSON.stringify(config)), template);
        let {configChildren, ...configChildless} = config;
        let item = {
          ...configChildless,
          contentId: shortid.generate(),
          contentIsRoot: mergedTemplate.contentIsRoot,
          contentParentId: contentParentId,
          configId: config.configId,
        };
        if (relativeToContentId ) {
          if (!moveBelow) {
            let target = _.findIndex(content, {contentId: relativeToContentId});
            let top = content.slice(0, target);
            let bottom = content.slice(target);
            content = top.concat([item],bottom);
          } else if (moveBelow) {
            let target = _.findIndex(content, {contentId: relativeToContentId});
            let top = content.slice(0, target+1);
            let bottom = content.slice(target+1);
            content = top.concat([item],bottom);
          }
        }
         else {
          content.push(item);
        }
        
        if (mergedTemplate.configChildren) {
          mergedTemplate.configChildren.map((child) =>{
            // These are always produced in order, so leave aboveContentId blank
            return makeItem(content, child, item.contentId);
          });
        }
        return content;
      }
      return makeItem(contentArr, {configId:action.configId}, action.contentParentId, action.relativeToContentId, action.moveBelow);
    
      
    case actions.ORPHAN_CONTENT_ITEM:
    case actions.RESTORE_ORPHANED_CONTENT_ITEM:
    case actions.UPDATE_CONTENT_ITEM:
    case actions.HIDE_CONTENT_ITEM:
      let itemKey = _.findIndex(contentArr, {contentId: action.contentId});
      contentArr[itemKey] = modifyItem(contentArr[itemKey], action);
      return contentArr;
      
      
    case actions.DELETE_CONTENT_ITEM:
      function deleteItem(contentId) {
        _.remove(contentArr, {contentId});
        let children = _.filter(contentArr, {contentParentId: contentId});
        children.map((o) => { return deleteItem(o.contentId) });
      }
      deleteItem(action.contentId);
      return contentArr;
      
    case actions.MOVE_CONTENT_ITEM:
      return ((content, {contentId, contentParentId, relativeToContentId, moveBelow}) => {
        let item = _.head(_.remove(content, {contentId}));
        if (contentParentId) {
          item.contentParentId = contentParentId;
        }
  
        if (relativeToContentId && !moveBelow) {
          let target = _.findIndex(content, {contentId: relativeToContentId});
          let top = content.slice(0, target);
          let bottom = content.slice(target);
          content = top.concat([item],bottom);
        } else if (relativeToContentId && moveBelow) {
          let target = _.findIndex(content, {contentId: relativeToContentId});
          let top = content.slice(0, target+1);
          let bottom = content.slice(target+1);
          content = top.concat([item],bottom);
        } else {
          content.push(item);
        }
        return content;
      })(contentArr, action);
      
    case actions.SET_CONTENT_ITEMS:
      return action.content;
    default:
      return contentArr;
  }
}


// WEBPACK FOOTER //
// ./src/App/Editor/state/content/reducers.js